<rt-assistant-list-card>
  <div class="layout">
    <rt-icon-container
      class="leading"
      shape="squircle"
      containerSize="large"
      size="small"
      name="work"
      color="colorIconEvaluationDefault"
      background="colorBgEvaluationLowDefault"
    />
    <div class="text">
      <span class="title">{{ data().title }}</span>
      <span class="meta">
        <span [class]="['status-dot', 'status-dot--' + data().status]"></span>
        <span>{{ statusLabel() }}</span>
        @if (data().candidatesCount !== undefined) {
          <span class="sep">&bull;</span>
          <span>{{ data().candidatesCount }} candidates</span>
        }
        @if (data().location; as loc) {
          <span class="sep">&bull;</span>
          <span>{{ loc }}</span>
        }
      </span>
    </div>
  </div>
</rt-assistant-list-card>
